import script from "./ProductsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductsList.vue?vue&type=script&lang=ts&setup=true"

import "./ProductsList.vue?vue&type=style&index=0&id=3bff46df&lang=css"

const __exports__ = script;

export default __exports__